export const separateEveryThousandByComma = (number: number): string =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const precisionDefault = 1;
export const formatCompactNumber = (
  number: number,
  precision: number = precisionDefault,
): string => {
  if (number < 1000) {
    return String(number);
  }

  if (number >= 1000 && number < 1_000_000) {
    return (number / 1000).toFixed(precision) + 'K';
  }

  // Since ES2021, JavaScript supports using underscores as numeric separators to make
  // large numbers easier to read in your code.

  if (number >= 1_000_000 && number < 1_000_000_000) {
    return (number / 1_000_000).toFixed(precision) + 'M';
  }

  if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
    return (number / 1_000_000_000).toFixed(precision) + 'B';
  }

  if (number >= 1_000_000_000_000 && number < 1_000_000_000_000_000) {
    return (number / 1_000_000_000_000).toFixed(precision) + 'T';
  }

  return String(number);
};
